module.exports = __webpack_public_path__ + "files/13649521354b74c2e380e902c481d9eb.png";